import { setLanguage } from "config/language";
import Banner from "../common/Banner";
import { useEffect, useState } from "react";
import BazAIHelmet from "../common/BazAIHelmet";
import { baseUrl } from "config/apiUrl";
import { inventoryPageData, inventoryFAQs } from "./inventorydata";
import UpdateNavbar from "pages/UpdatedLanding/Common/UpdateNavbar";
import UpdateFooter from "pages/UpdatedLanding/Common/UpdateFooter";
import EnhancedPageLayout from "pages/UpdatedLanding/Common/EnhancedPageLayout";

export default function LandingForInventoryManagement() {
  const [scrollTop, setScrollTop] = useState(0);
  useEffect(() => {
    function onScroll() {
      setScrollTop(document.documentElement.scrollTop);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);
  if (localStorage.getItem("lan") === null) {
    setLanguage();
  }

  return (
    <div className="bg-slate-50 min-h-screen">
      <BazAIHelmet
        title="Inventory Management Software — AI-Powered Stock Control"
        description="EkkBaz AI Inventory Management delivers real-time stock visibility, AI demand forecasting, and automated replenishment — reducing inventory costs by 40% and achieving 99.9% accuracy."
        keywords="inventory management software, AI inventory control, demand forecasting software, automated replenishment, stock management AI, multi-location inventory"
        image="/assets/images/LogoAI.png"
        url={`${baseUrl.webUrl}/product/inventory`}
        productName="Inventory Management"
        faqItems={inventoryFAQs}
      />
      <UpdateNavbar />
      <Banner
        headline="Inventory Management"
        subtitle="Real-time visibility, AI demand forecasting, and automated replenishment — eliminating stockouts while cutting inventory costs by 40%."
        from="inventory"
      />
      <EnhancedPageLayout {...inventoryPageData} />
      <UpdateFooter />
    </div>
  );
}
